import WebComponentContainer from '../generic/WebComponentContainer'
import React, { useEffect, useState } from 'react'
import useEventBus from '../generic/useEventBus'

const ConditionComponentWrapper = ({ conditionPageIsLoaded, updateGlobalState, yearId, makeId, modelId, trimId, colorId, transmissionId, engineId, drivetrainId, vin, mileage, allowIneligibleVehicleSubmission, navigateWithState, theme }) => {
  const [showLoader, setShowLoader] = useState(true)

  useEventBus('QuestionAnswered', event => {
    const { answered, conditions } = event
    const [[questionId, response]] = Object.entries(answered)

    if (answered.section !== 'conditions') return

    const comment = response === true && conditions[questionId]?.comment

    switch (typeof response) {
      case 'boolean':
        saveResponse(questionId, response ? 0 : undefined, comment)
        break
      case 'number':
        saveResponse(questionId, response)
        break
      case 'string':
        saveResponse(questionId, response || undefined)
        break
      default:
        break
    }
  })

  const saveResponse = (questionId, response, comment) => navigateWithState({ [questionId]: { v: response, c: comment || undefined } })

  useEventBus('ConditionFormValidated', event => {
    if (event.form === 'vehicle-conditions-form') {
      if (event.isConditionValid) {
        //skip is perfect condition modal
        updateGlobalState({ showNoDamageModal: false })
      } //unset so modal can be by other elements
      else updateGlobalState({ showNoDamageModal: true })

      const dataLayer = window.ICO.dataLayer
      if (dataLayer) {
        dataLayer.icoResponses = event.icoResponses
      }
    }
  })

  useEffect(() => {
    setShowLoader(true)
  }, [conditionPageIsLoaded])

  return (
    <WebComponentContainer pageLoadingComplete={conditionPageIsLoaded} withLoader={showLoader} location={'condition'} theme={theme}>
      <conditions-state-hydrator
        year-id={yearId}
        make-id={makeId}
        model-id={modelId}
        trim-id={trimId}
        color-id={colorId}
        transmission-id={transmissionId}
        engine-id={engineId}
        drivetrain-id={drivetrainId}
        vin={vin}
        mileage={mileage}
        allow-ineligible-vehicle-submission={allowIneligibleVehicleSubmission}
        theme={theme}>
        <vehicle-conditions />
      </conditions-state-hydrator>
    </WebComponentContainer>
  )
}

export default ConditionComponentWrapper
